type BuildMode = "development" | "staging" | "production";
export default function getBuildMode(): BuildMode {
  const { REACT_APP_BUILD_MODE } = process.env;
  const mode = (REACT_APP_BUILD_MODE || 'development') as BuildMode;
  return mode;
}